"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/ChatHeader/renderChatDesc.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


/* The header's second line: the chat's teams, then its description, as muted
 * text separated by middots ("(206) 466-0795 · Front Desk · Riverside Dental"). */
 const renderChatDesc = (teams, label) => (
  _react2.default.createElement('div', { className: "chat-header--desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 7}}
    ,  teams.length > 0 && (
      _react2.default.createElement('span', { className: "chat-header--teams", __self: this, __source: {fileName: _jsxFileName, lineNumber: 9}}
        ,  teams.map(t =>
          _react2.default.createElement('span', { className: "chat-header--team", key: t.teamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}},  t.name ),
        )
      )
    )
    ,  label && _react2.default.createElement('span', { className: "chat-header--desc-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}},  label ) 
  )
); exports.renderChatDesc = renderChatDesc
